import { useQuery } from "@tanstack/react-query";
import { useItemsApi } from "./useItemsApi";
import type { BiddingConfig } from "../types/BiddingConfig";

/**
 * 入札時最低落札値関連警告用の設定（警告倍率、禁止フラグ）を取得するクエリ
 * 入札入力画面で使用します。
 */
export const useBiddingConfigQuery = () => {
  const { getBiddingConfig } = useItemsApi();
  return useQuery<BiddingConfig, Error>({
    queryKey: ["systemmaster", "bidding-config"],
    queryFn: getBiddingConfig,
  });
};